<template>
    <div class="module container-fluid">
        <div class="detail-info" v-for="(item, index) in detailInfo" :key="index">
            <h2 v-if="item.type==='h2'">{{item.text}}</h2>

            <p v-if="item.type==='p'">{{item.text}}</p>

            <div v-if="item.type==='pics' ||  item.type==='video'">
                <div v-for="(obj, index) in item.banners" :key="index" class="obj-container">
                    <img v-if="obj.isPic"
                         :src="obj.imgSrc">

                    <CustomVideo class="story-video" v-if="obj.isVideo"
                                 :video="obj.video">
                    </CustomVideo>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomVideo from '../../common/CustomVideo'
    export default {
        name:'detailInfo',
        props: {
            detailInfo: Array,
        },
        components: {
            CustomVideo,
        }
    }
</script>

<style lang="less" scoped>
    .en {
        .detail-info {

            h2 {
                font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
            }
        }
    }

    .detail-info {

        h2 {
            margin-top: 100px;
            font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
            font-size: 24px;
            line-height: 30px;
        }

        p {
            max-width: 1000px;
            margin: 25px auto 100px auto;
            font-size: 14px;
            line-height: 25px;
        }

        .obj-container {
            &:nth-child(n+2) {
                margin-top: 10px;
            }
        }

        img {
            width: 100%;
        }

        .story-video {
            margin-top: 20px;
        }

        /deep/ .title {
            .module-title {
                font-size: 24px;
                line-height: 30px;
                font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
            }

            .module-sub-title {
                margin: 35px auto 0 auto;
                .text {
                    max-width: 1000px;
                    font-size: 14px;
                    line-height: 28px;
                }
            }
        }
    }
</style>
